var pug = require("!../../../../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cng-content\u003E\u003C\u002Fng-content\u003E";;return pug_html;};
module.exports = template;